import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addVisitorSuccess,
  addVisitorFailure,
  //
  deleteVisitorSuccess,
  deleteVisitorFailure,
  //
  editVisitorSuccess,
  editVisitorFailure,
  //
  fetchVisitorsSuccess,
  fetchVisitorsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  clockVisitorSuccess,
  clockVisitorFailure,
  //
  searchVisitorSuccess,
  searchVisitorFailure,
  //
  searchResidentSuccess,
  searchResidentFailure,
  //
  exportVisitorsSuccess,
  exportVisitorsFailure,
  //
  fetchEntriesSuccess,
  fetchEntriesFailure,
  findVisitorSuccess,
  findVisitorFailure,
} from "./actions";
import {
  ADD_VISITOR,
  DELETE_VISITOR,
  EDIT_VISITOR,
  FETCH_VISITORS,
  GET_VIEW_DATA,
  CLOCK_VISITOR,
  SEARCH_VISITOR,
  SEARCH_RESIDENT,
  EXPORT_VISITORS,
  FETCH_ENTRIES,
  FIND_VISITOR,
} from "./constants";

export function* fetchVisitorsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/visitor-list?${query}`);
    yield put(fetchVisitorsSuccess(data));
  } catch (e) {
    yield put(fetchVisitorsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching visitor list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/visitor/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching visitor data!"));
  }
}

export function* addVisitorSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/visitor/add`, payload);
    if (data) {
      yield put(successAlert("Visitor created successfully!"));
      yield put(addVisitorSuccess());
    }
  } catch (e) {
    yield put(addVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editVisitorSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/visitor/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Visitor updated successfully!"));
      yield put(editVisitorSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteVisitorSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/visitor/${payload}`);
    if (data) {
      yield put(successAlert("Visitor deleted successfully!"));
      yield put(deleteVisitorSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* clockVisitorSaga({ payload, onSuccess }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const data = yield call(
      api(token).post,
      `/api/visitor/check-in-out`,
      payload
    );
    if (data) {
      yield put(successAlert("Visitor clocked successfully!"));
      yield put(clockVisitorSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(clockVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchVisitorSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/active-visitor?${query}`);
    yield put(searchVisitorSuccess(data));
  } catch (e) {
    yield put(searchVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchResidentSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-resident?${query}`
    );
    yield put(searchResidentSuccess(data));
  } catch (e) {
    yield put(searchResidentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* exportVisitorsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { location_id, filter, title } = payload;
  let query = filter ? QueryString.stringify(filter) : "";
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/visitor-book-export/${location_id}?${query}`
    );
    if (data) {
      yield put(exportVisitorsSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${title}.csv`);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    yield put(exportVisitorsFailure());
    yield put(errorAlert(`Error while exporting visitors!`));
  }
}

export function* fetchEntriesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/entry-point-list?${query}`
    );
    yield put(fetchEntriesSuccess(data));
  } catch (e) {
    yield put(fetchEntriesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* findVisitorSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/search-visitor?${query}`);
    yield put(findVisitorSuccess(data));
  } catch (e) {
    yield put(findVisitorFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchVisitorsFlow() {
  yield takeEvery(FETCH_VISITORS, fetchVisitorsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addVisitorFlow() {
  yield takeEvery(ADD_VISITOR, addVisitorSaga);
}
export function* editVisitorFlow() {
  yield takeEvery(EDIT_VISITOR, editVisitorSaga);
}
export function* deleteVisitorFlow() {
  yield takeEvery(DELETE_VISITOR, deleteVisitorSaga);
}
export function* clockVisitorFlow() {
  yield takeEvery(CLOCK_VISITOR, clockVisitorSaga);
}
export function* searchVisitorFlow() {
  yield takeEvery(SEARCH_VISITOR, searchVisitorSaga);
}
export function* searchResidentFlow() {
  yield takeEvery(SEARCH_RESIDENT, searchResidentSaga);
}
export function* exportVisitorsFlow() {
  yield takeEvery(EXPORT_VISITORS, exportVisitorsSaga);
}
export function* fetchEntriesFlow() {
  yield takeEvery(FETCH_ENTRIES, fetchEntriesSaga);
}
export function* findVisitorFlow() {
  yield takeEvery(FIND_VISITOR, findVisitorSaga);
}

export default function* VisitorSaga() {
  yield all([
    fetchVisitorsFlow(),
    addVisitorFlow(),
    editVisitorFlow(),
    deleteVisitorFlow(),
    clockVisitorFlow(),
    getViewDataFlow(),
    searchVisitorFlow(),
    searchResidentFlow(),
    exportVisitorsFlow(),
    fetchEntriesFlow(),
    findVisitorFlow(),
  ]);
}
